import { render, staticRenderFns } from "./AddView.vue?vue&type=template&id=71056dd6&"
import script from "./AddView.vue?vue&type=script&lang=js&"
export * from "./AddView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports